import { useLayoutEffect } from 'react';

import { pages } from '@constants/pages';
import CalculatorList from '@pages/Private/Calculators';
import { CalculatorProvider } from '@pages/Private/Calculators/context/provider';
import CalculatorAntiEpilepticDrugs from '@pages/Private/Calculators/DayToDay/AntiEpilepticDrugs';
import { DrogasAntiEpileticasProvider } from '@pages/Private/Calculators/DayToDay/AntiEpilepticDrugs/context/provider';
import CalculatorConversationMlDrops from '@pages/Private/Calculators/DayToDay/ConversationMlDrops';
import { ConversorMlhEGotasProvider } from '@pages/Private/Calculators/DayToDay/ConversationMlDrops/context/provider';
import CalculatorCorticosteroidConverter from '@pages/Private/Calculators/DayToDay/CorticosteroidConverter';
import { ConversorCorticoideProvider } from '@pages/Private/Calculators/DayToDay/CorticosteroidConverter/context/provider';
import CalculatorGlomerularFiltrationRate from '@pages/Private/Calculators/DayToDay/GlomerularFiltrationRate';
import { TaxaFiltracaoGlomerularProvider } from '@pages/Private/Calculators/DayToDay/GlomerularFiltrationRate/context/provider';
import CalculatorOpioideConverter from '@pages/Private/Calculators/DayToDay/OpioidConverter';
import { ConversorOpioideProvider } from '@pages/Private/Calculators/DayToDay/OpioidConverter/context/provider';
import CalculatorRenalFunctionDoseCorrection from '@pages/Private/Calculators/DayToDay/RenalFunctionDoseCorrection';
import { CorrecaoDoseFuncaoRenalProvider } from '@pages/Private/Calculators/DayToDay/RenalFunctionDoseCorrection/context/provider';
import CalculatorEmergencyBurntHydration from '@pages/Private/Calculators/Emergency/BurntHydration';
import { HidratacaoQueimadoProvider } from '@pages/Private/Calculators/Emergency/BurntHydration/context/provider';
import { DisturbiosSodioProvider } from '@pages/Private/Calculators/Emergency/context/provider';
import CalculatorEmergencyContinuedSedation from '@pages/Private/Calculators/Emergency/ContinuedSedation';
import CalculatorEmergencyIotDrugs from '@pages/Private/Calculators/Emergency/IotDrugs';
import CalculatorEmergencySodiumDisorder from '@pages/Private/Calculators/Emergency/SodiumDisorder';
import CalculatorEmergencyVasoactiveDrugs from '@pages/Private/Calculators/Emergency/VasoactiveDrugs';
import CalculatorEmergencyVasodilatorDrugs from '@pages/Private/Calculators/Emergency/VasodilatorDrugs';
import CalculatorPediatricAntibioticDosage from '@pages/Private/Calculators/Pediatrics/PediatricAntibioticDosage';
import CalculatorPediatricEmergencyDose from '@pages/Private/Calculators/Pediatrics/PediatricEmergencyDose';
import CalculatorPediatricHydration from '@pages/Private/Calculators/Pediatrics/PediatricHydration';
import { HidratacaoPediatriaProvider } from '@pages/Private/Calculators/Pediatrics/PediatricHydration/context/provider';
import CalculatorPediatricSymptomaticDose from '@pages/Private/Calculators/Pediatrics/PediatricSymptomaticDose';
import DrugInteraction from '@pages/Private/DrugInteraction';
import DrugsList from '@pages/Private/Drugs';
import DrugsDetails from '@pages/Private/Drugs/Details';
import DrugsLayout from '@pages/Private/Drugs/Details/Menu.layout';
import Favorites from '@pages/Private/Favorites';
import Home from '@pages/Private/Home';
import Notes from '@pages/Private/Notes';
import NoteCreate from '@pages/Private/Notes/Create';
import NoteDetails from '@pages/Private/Notes/Details';
import NoteEdit from '@pages/Private/Notes/Edit';
import Payment from '@pages/Private/Payment';
import PrivacyPolicies from '@pages/Private/PrivacyPolicies';
import PrivateLayout from '@pages/Private/Private.layout';
import Search from '@pages/Private/Search';
import SuggestedTopic from '@pages/Private/SuggestTopic';
import Terms from '@pages/Private/Terms';
import ThemesList from '@pages/Private/Themes';
import ThemesDetails from '@pages/Private/Themes/Details';
import ThemesLayout from '@pages/Private/Themes/Details/Menu.layout';
import Profile from '@pages/Private/User/Profile';
import ForgotPassword from '@pages/Public/Auth/ForgotPassword';
import SignIn from '@pages/Public/Auth/SignIn';
import SignUp from '@pages/Public/Auth/SignUp';
import PublicPayment from '@pages/Public/Payment';
import { Route, Routes, useLocation } from 'react-router';

import NotFound from './NotFound';

function MainRoutes() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 20, left: 0, behavior: 'instant' });
  }, [pathname]);

  return (
    <Routes>
      <Route element={<PrivateLayout />}>
        <Route element={<Home />} index path={pages.home} />
        <Route element={<Profile />} path={pages.user.profile} />
        <Route element={<Search />} path={pages.search} />
        <Route element={<DrugInteraction />} path={pages.drugInteraction} />

        <Route element={<Notes />} path={pages.notes.list} />
        <Route element={<NoteCreate />} path={pages.notes.create} />
        <Route element={<NoteEdit />} path={pages.notes.editPrescription} />

        <Route element={<NoteDetails />} path={pages.notes.file} />

        <Route element={<Favorites />} path={pages.favorites} />

        <Route element={<SuggestedTopic />} path={pages.suggestTopic} />

        <Route path={pages.theme}>
          <Route element={<ThemesList />} index />
          <Route element={<ThemesLayout />}>
            <Route element={<ThemesDetails />} path="topicos/:topicId" />
          </Route>
        </Route>

        <Route element={<DrugsList />} path={pages.medicines.list} />

        <Route element={<DrugsLayout />}>
          <Route element={<DrugsDetails />} index path="/medicamentos/:id" />
        </Route>

        <Route element={<Payment />} path={pages.payment} />
        <Route element={<CalculatorList />} path={pages.calculators.list} />

        <Route
          element={
            <CalculatorProvider>
              <CalculatorEmergencyVasoactiveDrugs />
            </CalculatorProvider>
          }
          path={pages.calculators.vasoactiveDrugs}
        />
        <Route
          element={
            <CalculatorProvider>
              <CalculatorEmergencyVasodilatorDrugs />
            </CalculatorProvider>
          }
          path={pages.calculators.vasodilatorDrugs}
        />
        <Route
          element={
            <CalculatorProvider>
              <CalculatorEmergencyIotDrugs />
            </CalculatorProvider>
          }
          path={pages.calculators.iotDrugs}
        />
        <Route
          element={
            <CalculatorProvider>
              <CalculatorEmergencyContinuedSedation />
            </CalculatorProvider>
          }
          path={pages.calculators.continuedSedation}
        />
        <Route
          element={
            <DisturbiosSodioProvider>
              <CalculatorEmergencySodiumDisorder />
            </DisturbiosSodioProvider>
          }
          path={pages.calculators.sodiumDisorder}
        />
        <Route
          element={
            <HidratacaoQueimadoProvider>
              <CalculatorEmergencyBurntHydration />
            </HidratacaoQueimadoProvider>
          }
          path={pages.calculators.burntHydration}
        />

        <Route
          element={
            <TaxaFiltracaoGlomerularProvider>
              <CalculatorGlomerularFiltrationRate />
            </TaxaFiltracaoGlomerularProvider>
          }
          path={pages.calculators.glomerularFiltrationRate}
        />
        <Route
          element={
            <ConversorMlhEGotasProvider>
              <CalculatorConversationMlDrops />
            </ConversorMlhEGotasProvider>
          }
          path={pages.calculators.conversationMlDrops}
        />
        <Route
          element={
            <DrogasAntiEpileticasProvider>
              <CalculatorAntiEpilepticDrugs />
            </DrogasAntiEpileticasProvider>
          }
          path={pages.calculators.antiEpilepticDrugs}
        />
        <Route
          element={
            <ConversorCorticoideProvider>
              <CalculatorCorticosteroidConverter />
            </ConversorCorticoideProvider>
          }
          path={pages.calculators.corticosteroidConverter}
        />
        <Route
          element={
            <ConversorOpioideProvider>
              <CalculatorOpioideConverter />
            </ConversorOpioideProvider>
          }
          path={pages.calculators.opioidConverter}
        />

        <Route
          element={
            <CorrecaoDoseFuncaoRenalProvider>
              <CalculatorRenalFunctionDoseCorrection />
            </CorrecaoDoseFuncaoRenalProvider>
          }
          path={pages.calculators.renalFunctionDoseCorrection}
        />

        <Route
          element={
            <HidratacaoPediatriaProvider>
              <CalculatorPediatricHydration />
            </HidratacaoPediatriaProvider>
          }
          path={pages.calculators.pediatricHydration}
        />
        <Route
          element={
            <CalculatorProvider>
              <CalculatorPediatricAntibioticDosage />
            </CalculatorProvider>
          }
          path={pages.calculators.pediatricAntibioticDosage}
        />
        <Route
          element={
            <CalculatorProvider>
              <CalculatorPediatricSymptomaticDose />
            </CalculatorProvider>
          }
          path={pages.calculators.pediatricSymptomaticDose}
        />
        <Route
          element={
            <CalculatorProvider>
              <CalculatorPediatricEmergencyDose />
            </CalculatorProvider>
          }
          path={pages.calculators.pediatricEmergencyDose}
        />
      </Route>

      <Route element={<PublicPayment />} path={pages.checkout} />
      <Route element={<SignIn />} path={pages.auth.signIn} />
      <Route element={<SignUp />} path={pages.auth.signUp} />
      <Route element={<ForgotPassword />} path={pages.auth.forgotPassword} />
      <Route element={<PrivacyPolicies />} path={pages.privacyPolicies} />
      <Route element={<Terms />} path={pages.terms} />

      <Route element={<NotFound />} path="*" />
    </Routes>
  );
}

export default MainRoutes;
